import { apis } from './api'
import axios from 'axios'
import qs from 'qs';

axios.interceptors.request.use(config => { // config表示每次请求的内容
  config.headers['ACCEPT-LANGUAGE'] = localStorage.getItem('area')
  return config
}, error => { // 错误处理
  return Promise.reject(error)
})

export function axiosServer ({url = '', type = 'get', params = {}, subUrl = ''}) {
  url = getUrl(url) // url转换
  url += subUrl // 拼接子url
  url = replaceProxyUrl(url)
  // console.log('axiosServer request arguments:', arguments)
  let config = {
    method: type,
    url: url,
    data: params
  }
  if (type === 'get') {
    config.params = params
  }
  if (type === 'post') {
    config.data = qs.stringify(params);
  }
  return axios(config)
}

export function replaceProxyUrl (url) {
  if (process.env.NODE_ENV === 'production') {
    return url
  } else {
    return '/tapi' + url
  }
}
export function getParams (data) {
  if (data.errcode === 0) {
    return data
  } else {
    this.errorShow = true
  }
}
function getUrl (url) {
  if (!url || url.indexOf('/') !== -1) { // 是url时返回
    return url
  } else if (apis[url]) { // 根据url名称返回url值
    return apis[url]
  } else {
    return url
  }
}